var React = require('react');

function MenuComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M3 6h18v2H3V6zm0 5h18v2H3v-2zm18 5H3v2h18v-2z"}));
}

MenuComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MenuComponent;

MenuComponent.default = MenuComponent;
